// alterado - revisado

const mapaFinanceiroItemList = [
    {
        id: 'E10', 
        descricao: 'Rentabilidade Média',
        grupo: 'E',	
        nota: 
            [
                'Tem reservas mas não tem rentabilidade média igual IPCA',
                'Média de rentabilidade igual IPCA',
                'Média de rentabilidade até IPCA + 5%',
                'Média de rentabilidade até IPCA + 10%',
                'Média de rentabilidade acima IPCA + 10%',
            ],
        ordem: 110,
    },
    {
        id: 'E20', 
        descricao: 'Aquisição de Bens',
        grupo: 'E',	
        nota:
            [
                'Acumulado 10%',
                'Acumulado 30%',
                'Acumulado 50%',
                'Acumulado 75%',
                'Bens quitados ou Não quer bens ou tem dinheiro a vista com sobra para comprar',
            ],
        ordem: 120,
    },
    {
        id: 'E30', 
        descricao: 'Renda Variável',
        grupo: 'E',	
        nota:
            [
                'Retorno até 100% do Benchmark e investe até 5% do portfolio',
                'Retorno acima de 100% do Benchmark e investe até 5% do portfolio',
                'Retorno acima de 100% do Benchmark e investe entre 5%-10% do portfolio',
                'Retorno acima de 300% do Benchmark e investe entre 5%-10% do portfolio',
                'Retorno acima de 300% do Benchmark e investe mínimo de 10% do portfolio',
            ],
        ordem: 130,
    },
    {
        id: 'A10', 
        descricao: 'Longo Prazo',
        grupo: 'A',	
        nota:
            [
                'Retorno até 100% CDI e investe até 5% da renda',
                'Retorno acima de 100% CDI e investe até 5% da renda',
                'Retorno acima de 100% CDI e investe entre 5%-10% da renda',
                'Retorno acima de 300% CDI e investe entre 5%-10% da renda',
                'Retorno acima de 300% CDI e investe mínimo 10% da renda',
            ],
        ordem: 210,
    },
    {
        id: 'A20', 
        descricao: 'Médio Prazo',
        grupo: 'A',	
        nota:
            [
                '25% de reserva',
                '50% de reserva',
                '75% de reserva',
                '100% de reserva na Poupança ou similar',
                '100% de reserva com retorno mínimo de 100%CDI',
            ],
        ordem: 220,
    },
    {
        id: 'A30', 
        descricao: 'Curto Prazo',
        grupo: 'A',	
        nota:
            [
                '25% de reserva',
                '50% de reserva',
                '75% de reserva',
                '100% de reserva na Poupança ou similar',
                '100% de reserva com retorno mínimo de 100%CDI',
            ],
        ordem: 230,
    },
    {
        id: 'P10', 
        descricao: 'Proteção Patrimonial',
        grupo: 'P',	
        nota:
            [
                'Tem seguro de bens móveis apenas',
                'Tem seguro do carro apenas',
                'Tem seguro do carro e bens móveis apenas',
                'Tem seguro de carro e residência',
                'Tem todos os bens protegidos de forma completa',
            ],
        ordem: 310,
    },
    {
        id: 'P20', 
        descricao: 'Proteção de Saúde',
        grupo: 'P',	
        nota:
            [
                'Tem plano de saúde básico',
                'Tem plano de saúde',
                'Tem plano de saúde individual apenas',
                'Tem plano de saúde familiar porém incompleto',
                'Tem plano de saúde complet',
            ],
        ordem: 320,
    },
    {
        id: 'P30', 
        descricao: 'Proteção Pessoal',
        grupo: 'P',	
        nota:
            [
                'Tem seguro de vida/acidentes obrigatório no trabalho porém sem proteger toda renda',
                'Tem seguro de vida/acidentes até 20x a renda',
                'Tem seguro de vida/acidentes entre 20x e 60x de proteção',
                'Tem seguro de vida/acidentes entre 60x e 120x de proteção',
                'Tem seguro de vida/acidentes completo com mínimo 120x de proteção',
            ],
        ordem: 330,
    },
    {
        id: 'S10', 
        descricao: 'Mentalidade Investidora',
        grupo: 'S',	
        nota:
            [
                'Poupa até 10% da renda sem metas',
                'Poupa mais que 10% da renda sem metas',
                'Poupa até 20% da renda com metas',
                'Poupa acima de 20% da renda com metas',
                'Poupa acima de 20% da renda com metas ao receber receita',
            ],
        ordem: 410,
    },
    {
        id: 'S20', 
        descricao: 'Orçamento Estratégico',
        grupo: 'S',	
        nota:
            [
                'Não tem controle financeiro e está zero a zero',
                'Tem controle das contas fixas apenas',
                'Faz controle financeiro sem provisões',
                'Faz controle financeiro com provisões mas acompanha anualmente apenas',
                'Faz controle financeiro com provisões e acomapanha com frequência',
            ],
        ordem: 420,
    },
    {
        id: 'S30', 
        descricao: 'Controle de Gastos',
        grupo: 'S',	
        nota:
            [
                'Gasta todas suas receitas e fica zerado',
                'Tem pequenas sobras de até 10%',
                'Poupa entre 10% e 20%',
                'Poupa acima de 20%',
                'Poupa acima de 20% e tem reserva acúmulada',
            ],
        ordem: 430,
    },
]

export default mapaFinanceiroItemList